<template lang="html">
  <div class="alibabapayment__container">
    <b-form @submit.prevent="submitPayment" novalidate>
      <div class="">
        <p class="pt-3 pb-1">Email</p>
        <b-form-input
          class="col-md-12"
          type="text"
          name="email"
          :state="errors.first('email') && false"
          v-model="form.userEmail"
          v-validate="'required'"
          placeholder="Type Your Email Here"
        ></b-form-input>
        <p v-if="errors.has('email')" class="fontstyle__errormsg">
          {{ errors.first('email') }}
        </p>
      </div>
      <div>
        <p class="pt-4 pb-1">Membership Package</p>
        <multiselect
          v-model="selectedPackage"
          :options="optionsPaket || []"
          name="Membership Package"
          :state="errors.first('Membership Package') && false"
          :custom-label="customList"
          v-validate="'required'"
          placeholder="Select Your Package"
          @input="selectedPackageTotal('MEMBER')"
          :allow-empty="false"
          :show-labels="false">
            <span slot="noResult">Oops! No elements found.</span>
        </multiselect>
        <p v-if="errors.has('Membership Package')" class="fontstyle__errormsg">
            {{ errors.first('Membership Package') }}
        </p>
      </div>
      <div>
        <p class="pt-4 pb-1">Design Shop Services</p>
        <multiselect
          v-model="selectedDesignShop"
          :options="optionsDesignShop || []"
          :custom-label="customList"
          @input="selectedPackageTotal('DS')"
          name="Design Shop"
          :state="errors.first('Design Shop') && false"
          v-validate="'required'"
          :allow-empty="false"
          placeholder="Select Your Package"
          :show-labels="false">
            <span slot="noResult">Oops! No elements found.</span>
        </multiselect>
        <p v-if="errors.has('Design Shop')" class="fontstyle__errormsg">
            {{ errors.first('Design Shop') }}
        </p>
      </div>
      <div>
        <p class="pt-4 pb-1">Product Upload Services</p>
        <multiselect
          v-model="selectedProductUpload"
          :options="optionsProductUpload|| []"
          :custom-label="customList"
          name="Product Upload"
          :state="errors.first('Product Upload') && false"
          v-validate="'required'"
          @input="selectedPackageTotal('PU')"
          :allow-empty="false"
          placeholder="Select Your Package"
          :show-labels="false">
            <span slot="noResult">Oops! No elements found.</span>
        </multiselect>
        <p v-if="errors.has('Product Upload')" class="fontstyle__errormsg">
            {{ errors.first('Product Upload') }}
        </p>
      </div>
      <div>
        <p class="pt-4 pb-1">Additional Services</p>
        <multiselect
          v-model="selectedAdditional"
          :options="optionsAdditional || []"
          :custom-label="customList"
          name="Additional"
          :state="errors.first('Additional') && false"
          v-validate="'required'"
          @input="selectedPackageTotal('AD')"
          :allow-empty="false"
          placeholder="Select Your Package"
          :show-labels="false">
            <span slot="noResult">Oops! No elements found.</span>
        </multiselect>
        <p v-if="errors.has('Additional')" class="fontstyle__errormsg">
            {{ errors.first('Additional') }}
        </p>
      </div>
      <div class="">
        <p class="pt-3 pb-1">Promo Code</p>
        <div class="row m-0 justify-content-between">
          <b-form-input
            class="col-md-9"
            type="text"
            v-model="codePromo"
            placeholder="Type Your Promo Code Here"
          ></b-form-input>
          <button
            class="button__bluecorporite col-md-2 btn__check"
            type="button"
            @click="checkPromo"
            :disabled="!codePromo"
          >
            Check
          </button>
        </div>
        <p class="fontstyle__errormsg">{{errorMsg}}</p>
        <span v-if="isPromoCodeExist === 1 && form.promoCode">
          *promo code applied
        </span>
        <span v-else-if="isPromoCodeExist === 0 && form.promoCode">
          *promo code doesn't exist
        </span>
      </div>
      <div class="global__horborder fontstyle__default mt-5 pt-3 pb-3">
        <div class="row m-0 mt-2">
          <div class="col-md-6 p-0">Membership Package</div>
          <div class="col-md-5 p-0">
            <div class="row m-0">
              <p class="col-md-3 p-0">: IDR </p>
              <p class="col-md p-0 text-right">{{totalMembership | currency('', 0, { spaceBetweenAmountAndSymbol: true })}}</p>
            </div>
          </div>
        </div>
        <div class="row m-0 mt-2" v-if="promoActive.membership && isPromoCodeExist === 1">
          <div class="col-md-6 p-0">Membership Discount</div>
          <div class="col-md-5 p-0">
            <div class="row m-0">
              <p class="col-md p-0">: </p>
              <p class="col-md p-0 text-right">{{ afterDiscount.membership.discountPercentage || 0}} %</p>
              <span class="col-md-12 p-0 text-right">(Auto included on membership price)</span>
            </div>
          </div>
        </div>
        <div class="row m-0 mt-2">
          <div class="col-md-6 p-0">Design Shop Service</div>
          <div class="col-md-5 p-0">
            <div class="row m-0">
              <p class="col-md-3 p-0">: IDR </p>
              <p class="col-md p-0 text-right">{{totalDesignShop | currency('', 0, { spaceBetweenAmountAndSymbol: true })}}</p>
            </div>
          </div>
        </div>
        <div class="row m-0 mt-2">
          <div class="col-md-6 p-0">Product Upload Service</div>
          <div class="col-md-5 p-0">
            <div class="row m-0">
              <p class="col-md-3 p-0">: IDR </p>
              <p class="col-md p-0 text-right">{{totalProductUpload | currency('', 0, { spaceBetweenAmountAndSymbol: true })}}</p>
            </div>
          </div>
        </div>
        <div class="row m-0 mt-2">
          <div class="col-md-6 p-0">Additional Service</div>
          <div class="col-md-5 p-0">
            <div class="row m-0">
              <p class="col-md-3 p-0">: IDR </p>
              <p class="col-md p-0 text-right">{{totalAdditional | currency('', 0, { spaceBetweenAmountAndSymbol: true })}}</p>
            </div>
          </div>
        </div>
        <div class="row m-0 mt-2" v-if="promoActive.additional && isPromoCodeExist === 1">
          <div class="col-md-6 p-0">Additional Service Discount</div>
          <div class="col-md-5 p-0">
            <div class="row m-0">
              <p class="col-md p-0">: </p>
              <p class="col-md p-0 text-right">{{ afterDiscount.additional.discountPercentage || 0}} %</p>
              <span class="col-md-12 p-0 text-right">(Auto included on additional price)</span>
            </div>
          </div>
        </div>
      </div>
      <div class="global__horborder fontstyle__default pt-3">
        <div class="row m-0">
          <div class="col-md-6 p-0">Total</div>
          <div class="col-md-5 p-0">
            <div class="row m-0">
              <p class="col-md-3 p-0">: IDR</p>
              <p class="col-md p-0 text-right">{{totalFee | currency('', 0, { spaceBetweenAmountAndSymbol: true })}}</p>
            </div>
          </div>
        </div>
        <div class="row m-0 mt-2">
          <div class="col-md-6 p-0">Tax 10%</div>
          <div class="col-md-5 p-0">
            <div class="row m-0">
              <p class="col-md-3 p-0">: IDR</p>
              <p class="col-md p-0 text-right">{{totalTax | currency('', 0, { spaceBetweenAmountAndSymbol: true })}}</p>
            </div>
          </div>
        </div>
        <div class="row m-0 mt-2">
          <div class="col-md-6 p-0"><b>Grand Total</b></div>
          <div class="col-md-5 p-0">
            <div class="row m-0">
              <p class="col-md-3 p-0">: <b>IDR</b></p>
              <p class="col-md p-0 text-right"><b>{{ totalGrand | currency('', 0, { spaceBetweenAmountAndSymbol: true })}}</b></p>
            </div>
          </div>
        </div>
      </div>
      <div class="text-right">
      <button class="button__bluecorporite mt-3"
        type="submit">
        Submit
      </button>
    </div>
    </b-form>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'

const CATEGORY = {
  member: 'MEMBERSHIP',
  ds: 'DESIGN SHOP SERVICES',
  pu: 'PRODUCT UPLOAD SERVICES',
  ad: 'ADDITIONAL SERVICES'
}

export default {
  name: 'alibaba-payment',
  data () {
    return {
      paket_alert_msg: false,
      totalMembership: 0,
      totalDesignShop: 0,
      totalProductUpload: 0,
      totalAdditional: 0,
      totalFee: 0,
      totalTax: 0,
      totalGrand: 0,
      isPromoCodeExist: false,
      promoActive: {
        membership: false,
        additional: false
      },
      afterDiscount: {
        membership: null,
        additional: null
      },
      selectedPackage: null,
      selectedDesignShop: null,
      selectedProductUpload: null,
      selectedAdditional: null,
      codePromo: '',
      form: {
        userEmail: '',
        intervalCount: 12,
        totalAmount: 0,
        packages: [{}, {}, {}, {}],
        promoCode: ''
      },
      optionsPaket: null,
      optionsDesignShop: null,
      optionsProductUpload: null,
      optionsAdditional: null,
      errorMsg: ''
    }
  },
  computed: {
    ...mapGetters({
      account: 'settingAccount/account',
      error: 'settingAccount/error',
      isLoading: 'settingAccount/isLoading',

      listPckgMembership: 'alibabaPayment/listPckgMembership',
      errorPckgMembership: 'alibabaPayment/errorPckgMembership',
      isLoadingPckgMembership: 'alibabaPayment/isLoadingPckgMembership',

      listPckgDesignShop: 'alibabaPayment/listPckgDesignShop',
      errorPckgDesignShop: 'alibabaPayment/errorPckgDesignShop',
      isLoadingPckgDesignShop: 'alibabaPayment/isLoadingPckgDesignShop',

      listPckgProduct: 'alibabaPayment/listPckgProduct',
      errorPckgProduct: 'alibabaPayment/errorPckgProduct',
      isLoadingPckgProduct: 'alibabaPayment/isLoadingPckgProduct',

      listPckgAdditional: 'alibabaPayment/listPckgAdditional',
      errorPckgAdditional: 'alibabaPayment/errorPckgAdditional',
      isLoadingPckgAdditional: 'alibabaPayment/isLoadingPckgAdditional',

      postCekPromo: 'alibabaPayment/postCekPromo',
      errorCekPromo: 'alibabaPayment/errorCekPromo',
      isLoadingCekPromo: 'alibabaPayment/isLoadingCekPromo'
    })
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.form.userEmail = this.account.email
      this.fetchListMembership()
      this.fetchListDesignShop()
      this.fetchListProductUpload()
      this.fetchListAdditional()
    },

    async fetchListMembership () {
      await this.$store.dispatch('alibabaPayment/FETCH_PACKAGE_MEMBERSHIP').then(() => {
        if (this.listPckgMembership && this.listPckgMembership.data) {
          this.optionsPaket = this.listPckgMembership.data
        }
      })
    },

    async fetchListDesignShop () {
      await this.$store.dispatch('alibabaPayment/FETCH_PACKAGE_DESIGNSHOP').then(() => {
        if (this.listPckgDesignShop && this.listPckgDesignShop.data) {
          this.optionsDesignShop = this.listPckgDesignShop.data
        }
      })
    },

    async fetchListProductUpload () {
      await this.$store.dispatch('alibabaPayment/FETCH_PACKAGE_PRODUCT_UPLOAD').then(() => {
        if (this.listPckgProduct && this.listPckgProduct.data) {
          this.optionsProductUpload = this.listPckgProduct.data
        }
      })
    },

    async fetchListAdditional () {
      await this.$store.dispatch('alibabaPayment/FETCH_PACKAGE_ADDITIONAL').then(() => {
        if (this.listPckgAdditional && this.listPckgAdditional.data) {
          this.optionsAdditional = this.listPckgAdditional.data
        }
      })
    },

    async postCheckingPromo (payload) {
      await this.$store.dispatch('alibabaPayment/POST_CHECKING_PROMO', payload).then(() => {
        if (this.postCekPromo && this.postCekPromo.data) {
          this.isPromoCodeExist = 1
          this.discountPercent = `${this.postCekPromo.data}%`
          if (this.postCekPromo.data.category === CATEGORY.member) {
            this.promoActive.membership = true
            this.afterDiscount.membership = this.postCekPromo.data
            this.totalMembership = this.afterDiscount.membership.afterDiscountPrice
          } else if (this.postCekPromo.data.category === CATEGORY.ad) {
            this.promoActive.additional = true
            this.afterDiscount.additional = this.postCekPromo.data
            this.totalAdditional = this.afterDiscount.additional.afterDiscountPrice
          }
          this.calculateTotal()
        } else { // reset price
          this.isPromoCodeExist = 0
          this.selectedPackageTotal('MEMBER') 
          this.selectedPackageTotal('AD')
          this.promoActive = {
            membership: false,
            additional: false
          }
          this.afterDiscount = {
            membership: null,
            additional: null
          }
        }
      })
    },

    customList ({ price, type }) {
      const currency = this.getCurrency(price)
      return `IDR ${currency} – ${type}`
    },

    getCurrency (value) {
      let newValue = '-'
      if (value) {
        newValue = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return newValue
    },

    submitPayment () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.form.totalAmount = this.totalGrand
          this.$eventHub.$emit('dialog-payment-alibaba', this.form)
        }
      })
    },

    selectedPackageTotal (type) {
      let arr = 0
      let selectpackage = this.selectedPackage
      if (type === 'MEMBER') {
        this.totalMembership = this.selectedPackage.price || 0
        selectpackage = this.selectedPackage
        arr = 0
        this.errorMsg = ''
      } else if (type === 'DS') {
        this.totalDesignShop = this.selectedDesignShop.price || 0
        selectpackage = this.selectedDesignShop
        arr = 1
      } else if (type === 'PU') {
        this.totalProductUpload = this.selectedProductUpload.price || 0
        selectpackage = this.selectedProductUpload
        arr = 2
      } else if (type === 'AD') {
        this.totalAdditional = this.selectedAdditional.price || 0
        selectpackage = this.selectedAdditional
        arr = 3
      }

      this.form.packages[arr] = {
        id_package: selectpackage.id,
        price: selectpackage.price
      }
      this.calculateTotal()
    },

    calculateTotal () {
      this.totalFee = parseInt(this.totalMembership, 10) + parseInt(this.totalDesignShop, 10) +
                      parseInt(this.totalProductUpload, 10) + parseInt(this.totalAdditional, 10)
      this.totalTax = Math.round(this.totalFee * 0.1)
      this.totalGrand = Math.round(this.totalFee) + this.totalTax
    },

    checkPromo () {
      if (this.selectedPackage && this.codePromo) {
        // promo code tidak akan masuk payload selama btn check blm di click
        this.form.promoCode = this.codePromo 
        this.errorMsg = ''
        const payload = {
          packageId: this.selectedPackage.id,
          promoCode: this.form.promoCode
        }
        this.postCheckingPromo(payload)
      } else {
        this.errorMsg = 'Please select your Membership Package'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/paymentAlibaba/Payment.vue